import { mergeMap, catchError, map, switchMap, debounceTime } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of, concat } from 'rxjs';
import Global from '../../../store/global-selectors';
import { ModalService } from 'ui-components/services/modal-service';
import { SetReceivedDateModal } from '../../../components/modals/set-received-date-modal';
import * as ODActions from '../../../store/orders/order-details/orders.details.actions';
import * as Actions from './returns.details.actions';
import * as ReturnDetailsApi from './returns.details.api';

// TODO: SPD-14016
export const goToReturnDetails = (action$, _, { push, history }) => {
  return action$.pipe(
    ofType(Actions.RETURN_DETAILS_GO_TO_ROUTE),
    mergeMap(({ fulfillmentId }) => {
      const search = history.location.search;
      const historyPathName = history.location.pathname;
      const pathBeginning = historyPathName.includes('/return/')
        ? historyPathName.substr(0, historyPathName.indexOf('/return/'))
        : historyPathName;
      const returnPathParts = ['return', fulfillmentId];
      const pathname = [pathBeginning, ...returnPathParts].join('/');

      push({
        pathname,
        search,
      });
      return EMPTY;
    }),
  );
};

export const getReturnDetailsEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.GET_RETURN_DETAILS_REQUEST),
    mergeMap((action) => {
      const { returnDetailModalId } = action;
      const state = getState();
      // todo here
      const returnShipment = Global.selectReturnDetailsReturnByReturnDetailModalId(state, {
        returnDetailModalId,
      });
      if (!returnShipment) {
        return EMPTY;
      }

      const { fulfillmentId } = returnShipment;

      return ReturnDetailsApi.getReturnDetails(fulfillmentId).pipe(
        map((newReturn) => {
          return Actions.getReturnDetailsSuccess(newReturn, returnDetailModalId);
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};

export const refreshReturnDetailsEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.RETURN_DETAILS_MARK_AS_RECEIVED_SUCCESS),
    debounceTime(2000),
    switchMap((action) => {
      const { fulfillmentId } = action;
      const returnDetailsModalId = Global.selectReturnDetailsReturnDetailModalIdByFulfillmentId(getState(), { fulfillmentId });
      const refreshOd$ = of(ODActions.requestOrderDetails());
      if (returnDetailsModalId) {
        return concat(of(Actions.requestReturnDetails(returnDetailsModalId)), refreshOd$);
      }
      return refreshOd$;
    }),
  );
};

// TODO: Systemize the routing here
export const openReturnDetailsModal = (action$, _, { push, history }) => {
  return action$.pipe(
    ofType(Actions.RETURN_DETAILS_MODAL_OPEN),
    mergeMap((action) => {
      const { returnId, returnDetailModalId } = action;
      const search = history.location.search;
      const historyPathName = history.location.pathname;
      const pathname = [historyPathName, 'return', returnId].join('/');
      if (!historyPathName.includes('/return/')) {
        push({
          pathname,
          search,
        });
      }

      return of(Actions.requestReturnDetails(returnDetailModalId));
    }),
  );
};

// TODO: SPD-14016 decouple routing from our side effect management and global state.
export const closeReturnDetailsModal = (action$, _, { push, history }) => {
  return action$.pipe(
    ofType(Actions.RETURN_DETAILS_MODAL_CLOSED),
    mergeMap(() => {
      const search = history.location.search;
      const historyPathName = history.location.pathname;
      // Strip out /return/:returnId from the path
      const pathname = historyPathName.replace(/\/return\/\d+/, '');
      push({ pathname, search });
      return EMPTY;
    }),
  );
};

export const openSetReceivedDateModal = (action$) => {
  return action$.pipe(
    ofType(Actions.RETURN_DETAILS_OPEN_SET_RECEIVED_DATE_MODAL, Actions.RETURN_DETAILS_OPEN_UPDATE_RECEIVED_DATE_MODAL),
    mergeMap((action) => {
      const { type, fulfillmentId } = action;
      ModalService.launchModal({
        component: SetReceivedDateModal,
        props: {
          modalType: type === 'RETURN_DETAILS_OPEN_UPDATE_RECEIVED_DATE_MODAL' ? 'updateReceivedDate' : 'markAsReceived',
          selectedReturns: [fulfillmentId],
          isFromGrid: false,
        },
      });
      return EMPTY;
    }),
  );
};
